<template>
  <b-container id="visionLaserContainer" class="pt-5 pb-5">
    <div v-if="no_investments == 1" class="col-md-6 mx-auto justify-content-center my-5 text-center">
      <p class="fts-22 font-weight-bold light-white-03">Il semblerait que vous n'ayez pas encore de placements, il est temps de passer à l'action ! 😉</p>
    </div>
    <div v-else>
      <b-col>
        <b-row>
          <div class="title">
            La vision laser de votre patrimoine
          </div>
        </b-row>
        <b-row class="mt-4 subtitleText mb-4">
          <div style="width:100%">
            La répartition de votre portefeuille
          </div>
          <div style="width:100%">
            Vos enveloppes :
          </div>
        </b-row>
        <div style="display:flex;justify-content: space-between;align-content: center;margin-right: -20px;margin-left: -20px;">
          <CardSmallFirst v-for="(o, i) in comparisons_platforms" :key="i" :item="o" />
        </div>
      </b-col>
      <b-row>
        <b-col v-if="agg_assetclasses.length > 0" cols="12" md="6">
          <CardMedium title="Votre allocation d'actif" title2="Allocation d'actif" :content="agg_assetclasses" modalTitle="La vision laser de votre patrimoine">
            <ChartSector :sectors="agg_assetclasses" class="mt-4" />
          </CardMedium>
        </b-col>
        <b-col v-if="agg_countries.length > 0" cols="12" md="6">
          <CardMedium title="Répartition géographique" title2="Répartition géographique" :content="agg_countries" modalTitle="La vision laser de votre patrimoine">
            <Background class="mt-4" style="margin-left: 20px;margin-right: 20px;">
              <b-row style="font-weight: bold;padding:10px">
                <b-col style="text-align:left">Pays</b-col>
                <b-col style="text-align:center">Répartition</b-col>
              </b-row>
              <b-row v-for="(item, index) in agg_countries" :key="index" style="border-top: 2px solid #121212;padding:10px">
                <b-col style="text-align:left">{{ item.name }}</b-col>
                <b-col style="text-align:center">{{ Number(item.value).toFixed(0) }}%</b-col>
              </b-row>
            </Background>
          </CardMedium>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="agg_sectors.length > 0" cols="12" md="6">
          <CardMedium title="Votre allocation sectorielle" title2="Allocation sectorielle" :content="agg_sectors" modalTitle="La vision laser de votre patrimoine">
            <Background class="mt-4" style="margin-left: 20px;margin-right: 20px;">
              <b-row style="font-weight: bold;padding:10px">
                <b-col style="text-align:left">Secteur</b-col>
                <b-col style="text-align:center">Répartition</b-col>
              </b-row>
              <b-row v-for="(item, index) in agg_sectors" :key="index" style="border-top: 2px solid #121212;padding:10px">
                <b-col style="text-align:left">{{ item.name }}</b-col>
                <b-col style="text-align:center">{{ Number(item.value).toFixed(0) }}%</b-col>
              </b-row>
            </Background>
          </CardMedium>
        </b-col>
        <b-col v-if="agg_currencies.length > 0" cols="12" md="6">
          <CardMedium title="Devise" title2="Devise" content="devise" modalTitle="La vision laser de votre patrimoine">
            <Background class="mt-4" style="margin-left: 20px;margin-right: 20px;">
              <b-row style="font-weight: bold;padding:10px">
                <b-col style="text-align:left">Devise</b-col>
                <b-col style="text-align:center">Répartition</b-col>
              </b-row>
              <b-row v-for="(item, index) in agg_currencies" :key="index" style="border-top: 2px solid #121212;padding:10px">
                <b-col style="text-align:left">{{ item.name }}</b-col>
                <b-col style="text-align:center">{{ Number(item.value).toFixed(0) }}%</b-col>
              </b-row>
            </Background>
          </CardMedium>
        </b-col>
      </b-row>
      <div>
        <LookThrought :comparisons="agg_portfolio" />
      </div>
      <b-row>
        <DashboardPortefeuille :comparisons_platforms="comparisons_platforms" />
      </b-row>
    </div>
    <div class="row justify-content-center" style="margin-top:30px">
      <b-button
        style="background: #9561E2 0% 0% no-repeat padding-box;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 41px;
          opacity: 1;border:none"
        ><span
          style="text-align: center;
font: normal normal 600 1em Segoe UI;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;"
          >
          <a :href="'/scan/overview'">
          Accéder au diagnostic</a></span
        >
      </b-button>
    </div>
  </b-container>
</template>
<script>
import Background from "./comps/Background.vue";
import CardMedium from "./comps/CardMedium.vue";
import CardSmallFirst from "./comps/CardSmallFirst.vue";
import LookThrought from "./comps/LookThrough.vue";
import ChartSector from "./comps/ChartSector.vue";
import DashboardPortefeuille from "./comps/DashboardPortefeuille.vue";

export default {
  props: ["aggregate_assetclasses", "aggregate_countries", "aggregate_currencies", "aggregate_portfolio", "aggregate_sectors", "comparisons_platforms", "DashboardPortefeuille", "no_investments"],
  components: {
    CardSmallFirst,
    CardMedium,
    Background,
    LookThrought,
    ChartSector,
    DashboardPortefeuille,
  },
  data() {
    return {
      agg_assetclasses: this.aggregate_assetclasses,
      agg_sectors: this.aggregate_sectors,
      agg_currencies: this.aggregate_currencies,
      agg_countries: this.aggregate_countries,
      agg_portfolio: this.aggregate_portfolio,
    };
  },
  mounted() {
    this.agg_sectors = this.filterData(this.agg_sectors);
    this.agg_currencies = this.filterData(this.agg_currencies);
    this.agg_countries = this.filterData(this.agg_countries);
  },
  methods: {
    filterData(data) {
      let maxData = 0;
      let newArr = [];
      data.sort((a, b) => b.value - a.value);
      data.forEach((o) => {
        if (maxData < 7) {
          if (o.value > 1) {
            newArr.push(o);
            maxData += 1;
          }
        }
      });
      return newArr.sort((a, b) => a.name.localeCompare(b.name));
    },
  },
};
</script>
<style lang="scss">
@import "../../../../sass/_variables.scss";
#visionLaserContainer {
  background: #121212;
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
    width: 100%;
  }
  .subtitleText {
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
    width: 100%;
  }
}
</style>
